/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type Event_smartHoldEventInfo = {
    readonly " $fragmentRefs": FragmentRefs<"EventSmartHoldInfo_smartHoldEventInfo" | "EventTeam_smartHoldEventInfo" | "EventSummary_smartHoldEventInfo">;
    readonly " $refType": "Event_smartHoldEventInfo";
};
export type Event_smartHoldEventInfo$data = Event_smartHoldEventInfo;
export type Event_smartHoldEventInfo$key = {
    readonly " $data"?: Event_smartHoldEventInfo$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"Event_smartHoldEventInfo">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "Event_smartHoldEventInfo",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EventSmartHoldInfo_smartHoldEventInfo"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EventTeam_smartHoldEventInfo"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EventSummary_smartHoldEventInfo"
        }
    ],
    "type": "SmartHoldEventInfo",
    "abstractKey": null
} as any;
(node as any).hash = '4f6077674a8dbaa619ba1c77f94cc896';
export default node;
